/* GPD Healthy · storefront components (gpd-*) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function onCartUpdate(callback) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      return subscribe(PUB_SUB_EVENTS.cartUpdate, callback);
    }
    return function () {};
  }

  function cartJsonUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base.replace(/\/$/, '') + '.js';
  }

  function money(cents) {
    var fmt = (window.GPD && window.GPD.moneyFormat) || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    var s = n.toFixed(2);
    if (/no_decimals/.test(fmt)) s = String(Math.round(n));
    if (/amount_with_comma_separator/.test(fmt)) s = s.replace('.', ',');
    var parts = s.split(/[.,]/);
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, /comma_separator/.test(fmt) ? '.' : ',');
    s = parts.length > 1 ? parts[0] + (/comma_separator/.test(fmt) ? ',' : '.') + parts[1] : parts[0];
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
  }

  /* ------------------------------------------------------------------
     Header: sticky on scroll-up, cart counter, mobile drawer
     ------------------------------------------------------------------ */
  if (!customElements.get('gpd-header')) {
    customElements.define('gpd-header', class GpdHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || this;
        this.mode = this.dataset.sticky || 'on-scroll-up';
        this.countEls = Array.prototype.slice.call(this.querySelectorAll('[data-gpd-cart-count]'));
        this.cartLink = this.querySelector('[data-gpd-cart-link]');
        this.sink = this.querySelector('#cart-icon-bubble');
        this.lastY = window.pageYOffset || 0;
        this.isHidden = false;

        this.onScroll = this.onScroll.bind(this);
        if (this.mode === 'on-scroll-up') window.addEventListener('scroll', this.onScroll, { passive: true });

        if (this.sink && 'MutationObserver' in window) {
          this.observer = new MutationObserver(this.readSink.bind(this));
          this.observer.observe(this.sink, { childList: true, subtree: true, characterData: true });
        }

        this.unsubscribe = onCartUpdate(function () {
          this.show(true);
          this.refreshCount();
        }.bind(this));

        this.onPageShow = function (event) {
          if (!event.persisted) return;
          this.closeMenu(true);
          this.refreshCount();
        }.bind(this);
        window.addEventListener('pageshow', this.onPageShow);

        this.onCartClick = this.onCartClick.bind(this);
        if (this.cartLink) this.cartLink.addEventListener('click', this.onCartClick);

        this.menu = this.querySelector('[data-gpd-menu]');
        this.menuBtn = this.querySelector('[data-gpd-menu-open]');
        if (this.menu && this.menuBtn) this.bindMenu();

        this.bindMobilePlaceholder();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('pageshow', this.onPageShow);
        if (this.cartLink) this.cartLink.removeEventListener('click', this.onCartClick);
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribe) this.unsubscribe();
        clearTimeout(this.countTimer);
        if (this.onMenuKey) document.removeEventListener('keydown', this.onMenuKey);
        if (this.menuOpen) document.documentElement.classList.remove('gpd-scroll-lock');
        if (this.mqDesktop && this.onMq) {
          if (this.mqDesktop.removeEventListener) this.mqDesktop.removeEventListener('change', this.onMq);
          else if (this.mqDesktop.removeListener) this.mqDesktop.removeListener(this.onMq);
        }
        if (this.mqMobile && this.onMqMobile) {
          if (this.mqMobile.removeEventListener) this.mqMobile.removeEventListener('change', this.onMqMobile);
          else if (this.mqMobile.removeListener) this.mqMobile.removeListener(this.onMqMobile);
        }
      }

      bindMenu() {
        this.menuPanel = this.menu.querySelector('.gpd-drawer__panel');
        this.onMenuKey = this.onMenuKey.bind(this);
        this.menuBtn.addEventListener('click', this.openMenu.bind(this));
        Array.prototype.forEach.call(this.menu.querySelectorAll('[data-gpd-menu-close]'), function (el) {
          el.addEventListener('click', this.closeMenu.bind(this));
        }, this);
        if (window.matchMedia) {
          this.mqDesktop = window.matchMedia('(min-width: 990px)');
          this.onMq = function (event) { if (event.matches) this.closeMenu(true); }.bind(this);
          if (this.mqDesktop.addEventListener) this.mqDesktop.addEventListener('change', this.onMq);
          else if (this.mqDesktop.addListener) this.mqDesktop.addListener(this.onMq);
        }
      }

      openMenu() {
        if (!this.menu || this.menuOpen) return;
        this.menuOpen = true;
        this.show(true);
        this.menu.removeAttribute('inert');
        this.menu.setAttribute('aria-hidden', 'false');
        this.menu.classList.add('is-open');
        this.menuBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('gpd-scroll-lock');
        document.addEventListener('keydown', this.onMenuKey);
        var close = this.menu.querySelector('.gpd-drawer__close');
        window.setTimeout(function () { (close || this.menuPanel).focus(); }.bind(this), 60);
      }

      closeMenu(skipFocus) {
        if (!this.menu || !this.menuOpen) return;
        this.menuOpen = false;
        this.menu.classList.remove('is-open');
        this.menu.setAttribute('aria-hidden', 'true');
        this.menu.setAttribute('inert', '');
        this.menuBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('gpd-scroll-lock');
        document.removeEventListener('keydown', this.onMenuKey);
        if (skipFocus !== true) this.menuBtn.focus();
      }

      onMenuKey(event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
          event.preventDefault();
          this.closeMenu();
          return;
        }
        if (event.key !== 'Tab' && event.keyCode !== 9) return;
        var items = Array.prototype.filter.call(this.menuPanel.querySelectorAll('a[href], button:not([disabled])'), function (el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0;
        });
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.menuPanel)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      bindMobilePlaceholder() {
        var input = this.querySelector('.gpd-search__input[data-placeholder-mobile]');
        if (!input || !window.matchMedia) return;
        var mobileText = input.getAttribute('data-placeholder-mobile');
        if (!mobileText) return;
        var desktopText = input.getAttribute('placeholder') || '';
        this.mqMobile = window.matchMedia('(max-width: 749px)');
        this.onMqMobile = function () {
          input.setAttribute('placeholder', this.mqMobile.matches ? mobileText : desktopText);
        }.bind(this);
        this.onMqMobile();
        if (this.mqMobile.addEventListener) this.mqMobile.addEventListener('change', this.onMqMobile);
        else if (this.mqMobile.addListener) this.mqMobile.addListener(this.onMqMobile);
      }

      onCartClick(event) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          event.preventDefault();
          drawer.open(this.cartLink);
        }
      }

      isBusy() {
        if (this.menuOpen) return true;
        if (this.contains(document.activeElement) && document.activeElement !== document.body) return true;
        return !!this.querySelector('predictive-search[open], predictive-search[loading], .cart-notification.active');
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(function () {
          this.ticking = false;
          var y = Math.max(window.pageYOffset || 0, 0);
          var limit = this.section.offsetHeight + 120;
          if (y > this.lastY + 2 && y > limit) {
            if (!this.isBusy()) this.hide();
          } else if (y < this.lastY - 2 || y <= limit) {
            this.show();
          }
          this.lastY = y;
        }.bind(this));
      }

      hide() {
        if (this.isHidden) return;
        this.isHidden = true;
        this.section.classList.add('gpd-hdr-hidden');
      }

      show(instant) {
        if (!this.isHidden) return;
        this.isHidden = false;
        var section = this.section;
        if (!instant) { section.classList.remove('gpd-hdr-hidden'); return; }
        section.classList.add('gpd-hdr-instant');
        section.classList.remove('gpd-hdr-hidden');
        void section.offsetHeight;
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { section.classList.remove('gpd-hdr-instant'); });
        });
      }

      reveal() { this.show(true); }

      setCount(count) {
        var n = parseInt(count, 10);
        if (isNaN(n)) return;
        this.countEls.forEach(function (el) {
          el.classList.toggle('is-empty', n === 0);
          if (el.textContent.trim() === String(n)) return;
          el.textContent = n;
          el.classList.remove('is-bump');
          void el.offsetWidth;
          el.classList.add('is-bump');
          setTimeout(function () { el.classList.remove('is-bump'); }, 280);
        });
        if (this.cartLink) this.cartLink.setAttribute('aria-label', 'Cart: ' + n + (n === 1 ? ' item' : ' items'));
      }

      readSink() {
        if (!this.sink) return;
        var bubble = this.sink.querySelector('.cart-count-bubble');
        if (!bubble) { this.setCount(0); return; }
        var visible = bubble.querySelector('[aria-hidden="true"]');
        var n = visible ? parseInt(visible.textContent, 10) : NaN;
        if (isNaN(n)) this.refreshCount(); else this.setCount(n);
      }

      refreshCount() {
        clearTimeout(this.countTimer);
        this.countTimer = setTimeout(function () {
          fetch(cartJsonUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (response) { return response.ok ? response.json() : null; })
            .then(function (cart) { if (cart && typeof cart.item_count !== 'undefined') this.setCount(cart.item_count); }.bind(this))
            .catch(function () {});
        }.bind(this), 150);
      }
    });
  }

  /* ------------------------------------------------------------------
     Announcement rotator (mobile)
     ------------------------------------------------------------------ */
  if (!customElements.get('gpd-rotator')) {
    customElements.define('gpd-rotator', class GpdRotator extends HTMLElement {
      connectedCallback() {
        this.items = Array.prototype.slice.call(this.querySelectorAll('.gpd-ann__msg'));
        if (this.items.length < 2) return;
        this.index = Math.max(0, this.items.findIndex(function (el) { return el.classList.contains('is-active'); }));
        this.interval = Math.max(2000, (parseInt(this.dataset.interval, 10) || 4) * 1000);
        this.mq = window.matchMedia('(max-width: 749px)');
        this.tick = this.tick.bind(this);
        this.restart = this.restart.bind(this);
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.restart); else this.mq.addListener(this.restart);
        if (designMode) {
          this.onSelect = function (event) {
            var i = this.items.indexOf(event.target);
            if (i > -1) { this.hold = true; this.show(i); this.restart(); }
          }.bind(this);
          this.onDeselect = function (event) {
            if (this.items.indexOf(event.target) > -1) { this.hold = false; this.restart(); }
          }.bind(this);
          document.addEventListener('shopify:block:select', this.onSelect);
          document.addEventListener('shopify:block:deselect', this.onDeselect);
        }
        this.restart();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.mq) { if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.restart); else this.mq.removeListener(this.restart); }
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
        if (this.onDeselect) document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }
      restart() {
        clearInterval(this.timer);
        if (this.mq.matches && !reduceMotion.matches && !this.hold) this.timer = setInterval(this.tick, this.interval);
      }
      show(i) {
        this.items[this.index].classList.remove('is-active');
        this.index = (i + this.items.length) % this.items.length;
        this.items[this.index].classList.add('is-active');
      }
      tick() { if (!document.hidden) this.show(this.index + 1); }
    });
  }

  /* ------------------------------------------------------------------
     Hero slider (fade)
     ------------------------------------------------------------------ */
  if (!customElements.get('gpd-slider')) {
    customElements.define('gpd-slider', class GpdSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-gpd-slide]'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-gpd-dot]'));
        if (this.slides.length < 2) return;
        this.index = Math.max(0, this.slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
        this.delay = Math.max(3000, parseInt(this.dataset.interval, 10) || 6000);
        this.autoplay = this.dataset.autoplay === 'true';
        this.track = this.slides[0].parentNode;

        // Keep the slider height stable (tallest slide) so autoplay never shifts the layout below.
        this.equalize = function () {
          var max = 0;
          this.slides.forEach(function (slide) {
            var inner = slide.querySelector('.gpd-hero__grid') || slide;
            max = Math.max(max, inner.offsetHeight);
          });
          if (max) this.track.style.minHeight = max + 'px';
        }.bind(this);
        this.equalize();
        window.addEventListener('load', this.equalize);
        var resizeTimer;
        window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(this.equalize, 120); }.bind(this));

        var prev = this.querySelector('[data-gpd-prev]');
        var next = this.querySelector('[data-gpd-next]');
        if (prev) prev.addEventListener('click', function () { this.go(this.index - 1, true); }.bind(this));
        if (next) next.addEventListener('click', function () { this.go(this.index + 1, true); }.bind(this));
        this.dots.forEach(function (dot) {
          dot.addEventListener('click', function () { this.go(parseInt(dot.dataset.gpdDot, 10) || 0, true); }.bind(this));
        }, this);

        this.addEventListener('mouseenter', function () { this.hovering = true; this.stop(); }.bind(this));
        this.addEventListener('mouseleave', function () { this.hovering = false; this.start(); }.bind(this));
        this.addEventListener('focusin', function () { this.focused = true; this.stop(); }.bind(this));
        this.addEventListener('focusout', function (event) { if (!this.contains(event.relatedTarget)) { this.focused = false; this.start(); } }.bind(this));
        this.onVisibility = function () { if (document.hidden) this.stop(); else this.start(); }.bind(this);
        document.addEventListener('visibilitychange', this.onVisibility);

        this.bindSwipe();
        if (designMode) this.bindEditor();
        this.update();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
        if (this.onDeselect) document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }

      go(i, byUser) {
        var n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.update();
        if (byUser) this.start();
      }

      update() {
        this.slides.forEach(function (slide, i) {
          var active = i === this.index;
          slide.classList.toggle('is-active', active);
          if (active) { slide.removeAttribute('aria-hidden'); slide.removeAttribute('inert'); }
          else { slide.setAttribute('aria-hidden', 'true'); slide.setAttribute('inert', ''); }
        }, this);
        this.dots.forEach(function (dot, i) {
          var active = i === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        }, this);
      }

      start() {
        this.stop();
        if (!this.autoplay || reduceMotion.matches || this.hovering || this.focused || this.editorHold || document.hidden) return;
        this.timer = setInterval(function () { this.go(this.index + 1); }.bind(this), this.delay);
      }

      stop() { clearInterval(this.timer); this.timer = null; }

      bindSwipe() {
        var startX = null, startY = null, moved = false;
        this.addEventListener('touchstart', function (event) {
          var t = event.touches[0];
          startX = t.clientX; startY = t.clientY; moved = false;
          this.stop();
        }.bind(this), { passive: true });
        this.addEventListener('touchmove', function (event) {
          if (startX === null) return;
          var t = event.touches[0];
          var dx = t.clientX - startX, dy = t.clientY - startY;
          if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) moved = true;
        }, { passive: true });
        this.addEventListener('touchend', function (event) {
          if (startX === null) return;
          var dx = event.changedTouches[0].clientX - startX;
          if (moved && Math.abs(dx) > 40) { this.swipedAt = Date.now(); this.go(this.index + (dx < 0 ? 1 : -1), true); }
          else this.start();
          startX = null;
        }.bind(this), { passive: true });
        this.addEventListener('click', function (event) {
          if (this.swipedAt && Date.now() - this.swipedAt < 450) { event.preventDefault(); event.stopPropagation(); }
        }.bind(this), true);
      }

      bindEditor() {
        this.onSelect = function (event) {
          var i = this.slides.indexOf(event.target);
          if (i > -1) { this.editorHold = true; this.stop(); this.go(i); }
        }.bind(this);
        this.onDeselect = function (event) {
          if (this.slides.indexOf(event.target) > -1) { this.editorHold = false; this.start(); }
        }.bind(this);
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);
      }
    });
  }

  /* ------------------------------------------------------------------
     Tabs (product explainer)
     ------------------------------------------------------------------ */
  if (!customElements.get('gpd-tabs')) {
    customElements.define('gpd-tabs', class GpdTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-gpd-tab]'));
        this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-gpd-panel]'));
        this.tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () { this.select(i, true); }.bind(this));
          tab.addEventListener('keydown', function (event) {
            var dir = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
            if (!dir) return;
            event.preventDefault();
            var n = this.tabs.length;
            this.select(((i + dir) % n + n) % n, true);
          }.bind(this));
        }, this);
        if (designMode) {
          this.onSelect = function (event) {
            var i = this.panels.indexOf(event.target);
            if (i > -1) this.select(i);
          }.bind(this);
          document.addEventListener('shopify:block:select', this.onSelect);
        }
      }
      disconnectedCallback() { if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect); }
      select(i, focus) {
        this.tabs.forEach(function (tab, j) {
          var active = j === i;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          if (active && focus) tab.focus({ preventScroll: true });
          if (active && tab.scrollIntoView) tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        });
        this.panels.forEach(function (panel, j) {
          var active = j === i;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      }
    });
  }

  /* ------------------------------------------------------------------
     Product gallery (scroll-snap + thumbnails)
     ------------------------------------------------------------------ */
  if (!customElements.get('gpd-gallery')) {
    customElements.define('gpd-gallery', class GpdGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-gpd-gal-track]');
        if (!this.track) return;
        this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-gpd-gal-slide]'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-gpd-gal-thumb]'));
        this.index = 0;
        this.thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () { this.go(parseInt(thumb.dataset.gpdGalThumb, 10) || 0); }.bind(this));
        }, this);
        var prev = this.querySelector('[data-gpd-gal-prev]');
        var next = this.querySelector('[data-gpd-gal-next]');
        if (prev) prev.addEventListener('click', function () { this.go(this.index - 1); }.bind(this));
        if (next) next.addEventListener('click', function () { this.go(this.index + 1); }.bind(this));
        this.track.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + 1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index - 1); }
        }.bind(this));
        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
      }
      disconnectedCallback() { if (this.track) this.track.removeEventListener('scroll', this.onScroll); }
      go(i) {
        var n = this.slides.length;
        if (!n) return;
        i = ((i % n) + n) % n;
        this.track.scrollTo({ left: this.slides[i].offsetLeft - this.track.offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        this.setActive(i);
      }
      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(function () {
          this.ticking = false;
          var w = this.track.clientWidth || 1;
          this.setActive(Math.round(this.track.scrollLeft / w));
        }.bind(this));
      }
      setActive(i) {
        this.index = Math.max(0, Math.min(i, this.slides.length - 1));
        this.thumbs.forEach(function (thumb, j) {
          var active = j === this.index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active && thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, this);
      }
    });
  }

  /* ------------------------------------------------------------------
     Generic single-row carousel (scroll-snap track + arrows + progress bar)
     ------------------------------------------------------------------ */
  if (!customElements.get('gpd-carousel')) {
    customElements.define('gpd-carousel', class GpdCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-gpd-car-track]');
        if (!this.track) return;
        this.items = Array.prototype.slice.call(this.track.querySelectorAll('[data-gpd-car-item]'));
        this.bar = this.querySelector('[data-gpd-car-bar]');
        var prev = this.querySelector('[data-gpd-car-prev]');
        var next = this.querySelector('[data-gpd-car-next]');
        if (prev) prev.addEventListener('click', function () { this.step(-1); }.bind(this));
        if (next) next.addEventListener('click', function () { this.step(1); }.bind(this));
        this.track.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowRight') { event.preventDefault(); this.step(1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.step(-1); }
        }.bind(this));
        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.onScroll();
      }
      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
      page() {
        var first = this.items[0];
        if (!first) return this.track.clientWidth;
        var r0 = first.getBoundingClientRect();
        var gap = this.items.length > 1 ? Math.max(0, this.items[1].getBoundingClientRect().left - r0.right) : 0;
        var unit = r0.width + gap;
        var per = Math.max(1, Math.floor((this.track.clientWidth + gap + 2) / unit));
        return per * unit;
      }
      step(dir) {
        var t = this.track;
        var max = t.scrollWidth - t.clientWidth;
        var target = t.scrollLeft + dir * this.page();
        if (dir > 0 && t.scrollLeft >= max - 2) target = 0;
        else if (dir < 0 && t.scrollLeft <= 2) target = max;
        t.scrollTo({ left: Math.max(0, Math.min(target, max)), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(function () {
          this.ticking = false;
          var t = this.track;
          var max = t.scrollWidth - t.clientWidth;
          if (this.bar) {
            var w = max > 0 ? t.clientWidth / t.scrollWidth : 1;
            var x = max > 0 ? t.scrollLeft / max : 0;
            this.bar.style.setProperty('--w', (w * 100).toFixed(2) + '%');
            this.bar.style.setProperty('--x', (x * (100 / w - 100)).toFixed(2) + '%');
          }
          this.classList.toggle('is-start', t.scrollLeft <= 2);
          this.classList.toggle('is-end', t.scrollLeft >= max - 2);
          this.classList.toggle('is-static', max <= 2);
        }.bind(this));
      }
    });
  }

  /* ------------------------------------------------------------------
     Product page: pack selector, quantity, variant select, sticky bar
     ------------------------------------------------------------------ */
  function initPdp(root) {
    var form = root.querySelector('.gpd-buy__form form');
    var idInput = root.querySelector('[data-gpd-form-id]');
    var priceNow = root.querySelector('[data-gpd-buy-price] [data-gpd-price-now]');
    var priceWas = root.querySelector('[data-gpd-buy-price] [data-gpd-price-was]');
    var priceSave = root.querySelector('[data-gpd-buy-price] [data-gpd-price-save]');
    var per = root.querySelector('[data-gpd-buy-per]');
    var stickyPrice = root.querySelector('[data-gpd-sticky-price]');
    var mainBtn = root.querySelector('[data-gpd-main-atc]');

    function setPrice(cents) {
      var txt = money(cents);
      if (priceNow) priceNow.textContent = txt;
      if (stickyPrice) stickyPrice.textContent = txt;
    }

    /* packs */
    var packs = Array.prototype.slice.call(root.querySelectorAll('[data-gpd-pack]'));
    packs.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        packs.forEach(function (r) { r.closest('.gpd-pack').classList.toggle('is-selected', r === radio); });
        if (idInput) idInput.value = radio.value;
        setPrice(radio.dataset.price);
        if (priceWas) priceWas.closest('s').hidden = true;
        if (priceSave) priceSave.hidden = true;
        if (per) per.hidden = true;
        if (mainBtn) mainBtn.disabled = false;
      });
    });

    /* variant select (products with several options) */
    var sel = root.querySelector('[data-gpd-variant-select]');
    if (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (idInput) idInput.value = opt.value;
        setPrice(opt.dataset.price);
      });
    }

    /* quantity */
    var qty = root.querySelector('[data-gpd-qty]');
    if (qty) {
      var input = qty.querySelector('input');
      var clamp = function (v) { return Math.max(parseInt(input.min, 10) || 1, Math.min(parseInt(input.max, 10) || 99, v)); };
      qty.querySelector('[data-gpd-qty-minus]').addEventListener('click', function () { input.value = clamp((parseInt(input.value, 10) || 1) - 1); });
      qty.querySelector('[data-gpd-qty-plus]').addEventListener('click', function () { input.value = clamp((parseInt(input.value, 10) || 1) + 1); });
      input.addEventListener('change', function () { input.value = clamp(parseInt(input.value, 10) || 1); });
    }

    /* sticky bar (mobile) */
    var sticky = root.querySelector('[data-gpd-sticky]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      var stickyBtn = sticky.querySelector('[data-gpd-sticky-atc]');
      var io = new IntersectionObserver(function (entries) {
        var visible = entries.some(function (e) { return e.isIntersecting; });
        var pastIt = !visible && mainBtn.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', pastIt);
        sticky.setAttribute('aria-hidden', pastIt ? 'false' : 'true');
      }, { threshold: 0 });
      io.observe(mainBtn);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (window.matchMedia('(min-width: 990px)').matches) return;
        mainBtn.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        setTimeout(function () { mainBtn.click(); }, reduceMotion.matches ? 0 : 450);
      });
    }

    /* after add: visual confirmation on the main button */
    onCartUpdate(function (event) {
      if (!event || event.source !== 'product-form' || !mainBtn || !idInput) return;
      if (String(event.productVariantId || '') !== String(idInput.value)) return;
      var label = mainBtn.querySelector('span');
      if (!label) return;
      if (!mainBtn.dataset.gpdLabel) mainBtn.dataset.gpdLabel = label.innerHTML;
      label.textContent = '✓ Added to cart';
      mainBtn.classList.add('is-added');
      clearTimeout(mainBtn.gpdTimer);
      mainBtn.gpdTimer = setTimeout(function () { label.innerHTML = mainBtn.dataset.gpdLabel; mainBtn.classList.remove('is-added'); }, 2400);
    });
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-gpd-pdp]'), initPdp);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-gpd-pdp]') : null;
    if (root) initPdp(root);
  });

  /* ------------------------------------------------------------------
     Countdown (offers)
     ------------------------------------------------------------------ */
  function initCountdown(el) {
    var raw = (el.dataset.gpdCountdown || '').trim();
    var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
    if (!m) { el.hidden = true; return; }
    var hasTime = typeof m[4] !== 'undefined';
    var target = new Date(+m[1], +m[2] - 1, +m[3], hasTime ? +m[4] : 23, hasTime ? +m[5] : 59, hasTime ? 0 : 59);
    var d = el.querySelector('[data-gpd-cd="d"]'), h = el.querySelector('[data-gpd-cd="h"]'), mi = el.querySelector('[data-gpd-cd="m"]'), s = el.querySelector('[data-gpd-cd="s"]');
    var pad = function (v) { return (v < 10 ? '0' : '') + v; };
    function render() {
      var ms = Math.max(0, target - new Date());
      if (d) d.textContent = Math.floor(ms / 864e5);
      if (h) h.textContent = pad(Math.floor(ms / 36e5) % 24);
      if (mi) mi.textContent = pad(Math.floor(ms / 6e4) % 60);
      if (s) s.textContent = pad(Math.floor(ms / 1e3) % 60);
      if (ms <= 0) el.hidden = true;
    }
    render();
    setInterval(render, 1000);
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-gpd-countdown]'), initCountdown);

  /* ------------------------------------------------------------------
     Collection sort
     ------------------------------------------------------------------ */
  Array.prototype.forEach.call(document.querySelectorAll('[data-gpd-sort]'), function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ------------------------------------------------------------------
     "Added" feedback on gpd-atc buttons (cards, offers, explainer)
     ------------------------------------------------------------------ */
  if (!window.__gpdAtcFeedback) {
    window.__gpdAtcFeedback = true;
    onCartUpdate(function (event) {
      if (!event || event.source !== 'product-form') return;
      var id = String(event.productVariantId || '');
      Array.prototype.forEach.call(document.querySelectorAll('.gpd-atc:not(.gpd-buy__form)'), function (form) {
        var input = form.querySelector('input[name="id"]');
        var button = form.querySelector('button[type="submit"]');
        if (!input || !button || String(input.value) !== id) return;
        var label = button.querySelector('span');
        if (!label) return;
        if (!button.dataset.gpdLabel) button.dataset.gpdLabel = label.innerHTML;
        label.textContent = '✓ Added';
        button.classList.add('is-added');
        clearTimeout(button.gpdTimer);
        button.gpdTimer = setTimeout(function () { label.innerHTML = button.dataset.gpdLabel; button.classList.remove('is-added'); }, 2400);
      });
    });
  }
})();
